import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../axiosInstance";
export const getTopic = createAsyncThunk(
  "get/topic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get("topicList", {
        params: payload,
      });
      return response.data;
    } catch (error) {
      console.log(error);
      rejectWithValue(error);
    }
  }
);
export const createTopic = createAsyncThunk(
  "create/topic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post("addTopic", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const editTopic = createAsyncThunk(
  "edit/topic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.put("editTopic", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
export const topicStatusChanged = createAsyncThunk(
  "status/topic",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.patch("topicStatusChanged", payload);
      return response.data;
    } catch (error) {
      console.log({ error });
      rejectWithValue(error);
    }
  }
);
const topicDetails = createSlice({
  name: "topicDetails",
  initialState: {
    topics: [],
    loading: false,
  },
  extraReducers: (builder) => {
    builder.addCase(getTopic.pending, (state, payload) => {
      state.loading = true;
    });
    builder.addCase(getTopic.fulfilled, (state, payload) => {
      state.loading = false;
      state.topics = payload;
    });
    builder.addCase(getTopic.rejected, (state, payload) => {
      state.loading = false;
      console.log(payload);
    });
  },
});

export default topicDetails.reducer;
